import { render } from "./HandymanSummary.vue?vue&type=template&id=3c9fc5ce&scoped=true"
import script from "./HandymanSummary.vue?vue&type=script&lang=js"
export * from "./HandymanSummary.vue?vue&type=script&lang=js"

import "./HandymanSummary.vue?vue&type=style&index=0&id=3c9fc5ce&scoped=true&lang=css"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c9fc5ce"]])

export default __exports__